<template>
    <Dialog v-model="isOpen" max-width="500">
        <v-card-text>
            <p>Caro parceiro, você confirma que o e-mail digitado para o seu cliente está correto? Sugerimos confirmar para evitar possíveis complicações.</p>
            <p class="font-weight-bold email-text"> E-mail digitado: {{ conf_email }}</p>
        </v-card-text>
        <v-card-actions class="justify-end">
            <v-btn color="secondary" @click="alterar">Alterar</v-btn>
            <v-btn color="primary" @click="confirmar">Confirmar</v-btn>
        </v-card-actions>
    </Dialog>
</template>

  <script>

  export default {
    name: 'DialogConfirmarEmail',
    props: {
      value: Boolean,
      email: String
    },
    data: () => ({
      conf_email: ''
    }),
    computed: {
      isOpen: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        }
      }
    },
    watch: {
      value (open) {
        if (open) {
          this.conf_email = this.email
        }
      }
    },
    methods: {
      confirmar () {
        this.$emit('input', false)
        this.$emit('confirmar', this.conf_email)
      },
      alterar () {
        this.$emit('input', false)
        this.$emit('alterar')
      }
    }
  }
  </script>

  <style scoped>
  .title {
    color: var(--secondary);
  }
  </style>
